import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import Player from '@vimeo/player';
import ButtonCircle from '@components/ButtonCircle';
import * as styles from './styles';

const VideoPlayer = ({ video }) => {
  const [showPlayButton, setShowPlayButton] = useState(!video.autoplay);
  const ref = useRef();

  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });
  const setRefs = useCallback(
    (node) => {
      ref.current = node;
      inViewRef(node);
    },
    [inViewRef],
  );

  let player = {};

  useEffect(() => {
    if (ref.current) {
      if (video.autoplay) {
        player = new Player(ref.current, {
          url: video.url,
          width: 1244,
          autoplay: false,
          muted: true,
          controls: true,
          loop: true,
          speed: true,
          playsinline: true,
          autopause: true,
        });
        ref.current.addEventListener('click', () => {
          player.play().catch((error) => {
            // console.log(error);
          });
          setShowPlayButton(null);
        });
        player.on('pause', () => {
          player.setVolume(1);
          setShowPlayButton(true);
        });
        if (inView) {
          player.play().catch((error) => {
            // console.log(error);
          });
        }
      } else {
        player = new Player(ref.current, {
          url: video.url,
          width: 1244,
          autoplay: false,
          speed: true,
          playsinline: false,
          loop: true,
          autopause: true,
        });
        ref.current.addEventListener('click', () => {
          player.play().catch((error) => {
            // console.log(error);
          });
          setShowPlayButton(null);
        });
        player.on('pause', () => {
          setShowPlayButton(true);
        });
      }
    }
  }, [inView]);

  return (
    <div ref={setRefs} className={styles.videoContainer}>
      <div data-context={showPlayButton ? 'Play' : null}>
        <div
          role="presentation"
          className={styles.videoCover}
          style={{ zIndex: showPlayButton ? '10' : '0' }}
        >
          {!video.autoplay && (
            <ButtonCircle
              label="Play"
              data-context="Play"
              aria-label="Play"
              className={styles.videoButton}
            />
          )}
        </div>
      </div>
    </div>
  );
};

VideoPlayer.propTypes = {
  video: PropTypes.shape({
    url: PropTypes.string,
    autoplay: PropTypes.bool,
  }),
};

VideoPlayer.defaultProps = {
  video: {
    url: '',
    autoplay: false,
  },
};

export default VideoPlayer;
